import { useEffect, useState } from "react";
import { getUsersList } from "../../../services/adminService";
import { getImage } from "../../../utils/cloudinarySizing";

const AdminUsers = () => {
  const [search, setSearch] = useState("");
  const [users, setUsers] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalResults, setTotalResults] = useState(0);

  const fetchUsers = async (pageNumber = 1, searchTerm = search) => {
    const data = await getUsersList({
      page: pageNumber,
      search: searchTerm,
    });

    setUsers(data.results);
    setPage(pageNumber);
    setTotalPages(Math.ceil(data.count / 20));
    setTotalResults(data.count);
  };

  useEffect(() => {
    fetchUsers(1);
  }, []);

  return (
    <div className="admin-users">
      <div className="users-header">
        <h2>Users</h2>

        <div className="users-results">
          {totalResults} results
        </div>
      </div>

      <div className="user-search-row">
        <div className="search-input-wrapper">
          <input
            type="text"
            placeholder="Search by name or username..."
            value={search}
            onChange={(e) => {
              const value = e.target.value;
              setSearch(value);

              if (value === "") {
                fetchUsers(1, "");
              }
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                fetchUsers(1, search);
              }
            }}
          />

          {search && (
            <button
              type="button"
              className="clear-search-btn"
              onClick={() => {
                setSearch("");
                fetchUsers(1, "");
              }}
            >
              ✕
            </button>
          )}
        </div>

        <button onClick={() => fetchUsers(1, search)}>
          Search
        </button>
      </div>

      {
        users.length === 0 ? (
          <p>No users found.</p>
        ) : (
          <ul>
            {users.map((user) => (
              <li key={user.id} className="list-row">

                <div className="user-left">

                  <div className="user-avatar">
                    {user.profile?.photo_original ? (
                      <img
                        src={getImage(user.profile.photo_original, "avatar_sm")}
                        alt={user.username}
                      />
                    ) : (
                      <div className="avatar-placeholder">
                        {user.username.charAt(0).toUpperCase()}
                      </div>
                    )}
                  </div>


                  <div className="row-main">
                    <strong>
                      {user.first_name || user.last_name
                        ? `${user.first_name} ${user.last_name}`
                        : user.username}
                    </strong>

                    <div>@{user.username}</div>

                    <div>{user.email || "No email provided"}</div>
                  </div>

                </div>


                <div className="profile-info">

                  {(user.profile?.city || user.profile?.state || user.profile?.country) && (
                    <div>
                      Location:{" "}
                      {[
                        user.profile.city,
                        user.profile.state,
                        user.profile.country,
                      ]
                        .filter(Boolean)
                        .join(", ")}
                    </div>
                  )}

                  {user.profile?.phone_number && (
                    <div>
                      Phone: {user.profile.phone_number}
                    </div>
                  )}

                </div>


                <div className="row-right">
                  <div className="account-created">
                    <span className="label">
                      Account created
                    </span>

                    <span className="row-date">
                      {new Date(user.date_joined).toLocaleString([], {
                        year: "numeric",
                        month: "short",
                        day: "2-digit",
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </span>
                  </div>
                </div>

              </li>
            ))}
          </ul>
        )
      }
      {users.length > 0 && (
        <div className="pagination">

          <button
            disabled={page === 1}
            onClick={() => fetchUsers(page - 1)}
          >
            Previous
          </button>

          <span>
            Page {page} of {totalPages}
          </span>

          <button
            disabled={page === totalPages}
            onClick={() => fetchUsers(page + 1)}
          >
            Next
          </button>

        </div>
      )}
    </div >
  );
};

export default AdminUsers;